import apiConfig from "../../config/apiConfig";
import { objToQueryString } from "../../services/helpers/Helper";
import { COMMENT_POST_TYPE, END_POINT } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const fetchPostComment = (post_id, callbackSuccess) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         post_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LIST_COMMENTS_POST}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: COMMENT_POST_TYPE.FETCH,
            payload: response.data
         });
         callbackSuccess && callbackSuccess();
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const deleteCommentPost = (comment_id) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         comment_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.DELETE_COMMENT_POST}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then(() => {
         dispatch({
            type: COMMENT_POST_TYPE.DELETE,
            payload: comment_id
         })
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };